/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-05 22:47:54
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-07 15:53:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductsLinkProduct/Components/SecondaryOptions/index.tsx
 */
import { Input, SectionCollapse, Table } from '@/src/components/Antd';
import React from 'react';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './style.module.less';

type Props = {
  originalOptions: Array<any>;
  options: Array<any>;
  disabled?: boolean;
  handleChangeLabel: (index: number, e: any) => void;
  handleChangeValue: (index: number, optionIndex: number, e: any) => void;
};

function SecondaryOptions({
  options,
  originalOptions,
  disabled,
  handleChangeLabel,
  handleChangeValue,
}: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const columns = (optionIndex: number) => {
    return [
      {
        dataIndex: 'value',
        title: getI18n('general.value'),
        width: '50%',
        default: true,
      },
      {
        title: getI18n(
          'salesChannelProductDetail.index.valuelabelinthislanguage',
        ),
        default: true,
        width: '50%',
        render: (text: string, record: any, index: number) => {
          return (
            <Input
              className={styles.tableInput}
              value={options[optionIndex]?.values[index]}
              disabled={disabled}
              onChange={handleChangeValue.bind(this, index, optionIndex)}
            />
          );
        },
      },
    ];
  };

  const dataSource = (option) => {
    if (Array.isArray(option.values))
      return option.values.map((v) => ({ value: v }));
    else return [];
  };

  const renderContent = () => {
    return (
      <div className={styles.content}>
        {originalOptions.map((option, index) => {
          return (
            <div className={styles.option} key={option.uuid}>
              <div className={styles.title}>
                <span>{`${getI18n('salesChannelProductDetail.index.option')} ${
                  index + 1
                } - ${option.label}*`}</span>
                <span className={styles.limit}>{`${
                  options[index]?.label?.length || 0
                }/50`}</span>
              </div>
              <div className={styles.subTitle}>
                <span>
                  {getI18n(
                    'salesChannelProductDetail.index.edittheoptionlabelinthislanguage',
                  )}
                </span>
              </div>
              <div className={styles.titleInput}>
                <Input
                  maxLength={50}
                  className={styles.titleInputField}
                  size={'large'}
                  value={options[index]?.label}
                  disabled={disabled}
                  onChange={handleChangeLabel.bind(this, index)}
                />
              </div>
              <div className={styles.table}>
                <Table
                  scroll={{ y: 383 }}
                  rowKey={'value'}
                  id={option.label}
                  columns={columns(index)}
                  dataSource={dataSource(option)}
                  pagination={false}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderTitle = () => {
    return (
      <div className={styles.title}>
        <div className={'collapseTitle'}>
          {getI18n('salesChannelProductDetail.index.options')}
        </div>
        <div className={styles.subTitle}>
          {getI18n('salesChannelProductDetail.index.optionsSubtitle')}
        </div>
      </div>
    );
  };
  return (
    <div className={styles.container}>
      <SectionCollapse
        open={true}
        id={'salesChannelLinkProductPriceLanguage'}
        titleStyle={{ height: '64px' }}
        title={renderTitle()}
        content={renderContent()}
        openMargin={16}
      />
    </div>
  );
}

export default SecondaryOptions;
